import intlTelInput from "intl-tel-input/dist/js/intlTelInput.mjs";
import intlTelInputUtils from "intl-tel-input/dist/js/utils.js";
import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
import "../utils/utm-tags-handlers.js";

// Accordion
import "./unifiedAccordionStandalone.js";
// Utils
import "./utils/assetPath.js";
import "./utils/cookies.js";
import "./utils/geoLocation.js";
import "./utils/validation.js";
import "./utils/promoText.js";
// Components
import "./components/accordion.js";
// Data
import "./data/countryCodes.js";
// Components
import "./components/regionSelector.js";
import "./components/phoneFlagSelector.js";
// Translation modules
import "./translation/translations.js";
import "./translation/translateDate.js";
import "./translation/translatePage.js";
import "./translation/languageSwitcher.js";
// Components
import "./components/campusSlider.js";
import "./components/heroSlider.js";
import "./components/reviewsSlider.js";
import "./components/newsSlider.js";
import "./components/teachersSlider.js";
import "./components/advantagesSlider.js";
import "./components/priceSlider.js";
// Forms
import "./forms/downloadBrochureForm.js";
// Internal sources
import "./script.js";
// 
import "./internal_sources/shared/internalLeadForms.js";
// Kindergarten
import "./internal_sources/kindergarten/videoSlider.js";
import "./internal_sources/kindergarten/trialDayForm.js";
import "./internal_sources/kindergarten/kindergartenFeaturesSlider.js";
import "./internal_sources/kindergarten/kindergartenAdvantagesSlider.js";
import "./internal_sources/kindergarten/kindergartenPriceFilter.js";
// Secondary
import "./internal_sources/secondary/schoolAdvantagesSlider.js";
import "./internal_sources/secondary/secondaryHeroFeaturesSlider.js";
import "./internal_sources/secondary/script.js";
// Primary
import "./internal_sources/primary/script.js";

// Phone mask
window.intlTelInput = intlTelInput;
window.intlTelInputUtils = intlTelInputUtils;

window.addEventListener("load", function () {
  polyfillCountryFlagEmojis();
});

function syncSiteLanguage() {
  var language = document.body && document.body.dataset ? document.body.dataset.siteLanguage : "";
  if (!language) return;
  localStorage.setItem("siteLanguage", language);
}

function currentRegionName() {
  var curCountry = document.getElementById("curCountry");
  if (curCountry && curCountry.textContent.trim()) {
    return curCountry.textContent.trim();
  }

  return window.location.pathname.indexOf("-uz/") >= 0 ? "Узбекистан" : "Россия";
}

function refreshPhoneMasks() {
  var regionName = currentRegionName();
  if (typeof window.updatePhoneInputsLimits === "function") {
    window.updatePhoneInputsLimits(regionName);
  }
  setTimeout(function () {
    if (typeof window.updatePhoneInputsLimits === "function") {
      window.updatePhoneInputsLimits(regionName);
    }
  }, 150);
}

function initInternalHeaderScroll() {
  var navBar = document.querySelector(".nav-bar");
  var topBar = document.querySelector(".top_bar");
  var iconsMenuBtn = document.getElementById("iconsMenuBtn");
  if (!navBar) return;

  var lastScrollTop = 0;

  function updateNavBarPosition() {
    if (!topBar) return;
    var topBarRect = topBar.getBoundingClientRect();
    var finalHeight = topBarRect.bottom > 0 ? topBarRect.bottom : (window.innerWidth >= 1196 ? 90 : 74);
    document.documentElement.style.setProperty("--top-bar-height", finalHeight + "px");
  }

  function updateNavBarVisibility() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var iconsContainer = iconsMenuBtn ? iconsMenuBtn.closest(".icons") : null;
    var contactsContainer = iconsContainer ? iconsContainer.closest(".contacts") : null;

    updateNavBarPosition();

    if (scrollTop > lastScrollTop && scrollTop > 10) {
      navBar.classList.add("nav-bar-scrolled");
      navBar.classList.remove("mobile-menu-open");
      if (iconsMenuBtn) {
        iconsMenuBtn.classList.remove("hidden");
        iconsMenuBtn.classList.add("visible");
      }
      if (iconsContainer) iconsContainer.classList.add("has-menu-btn");
      if (contactsContainer) contactsContainer.classList.add("has-menu-btn");
      if (topBar) topBar.classList.add("has-menu-btn");
    } else {
      navBar.classList.remove("nav-bar-scrolled");
      if (scrollTop <= 10) navBar.classList.remove("mobile-menu-open");
      if (iconsMenuBtn) {
        iconsMenuBtn.classList.add("hidden");
        iconsMenuBtn.classList.remove("visible");
      }
      if (iconsContainer) iconsContainer.classList.remove("has-menu-btn");
      if (contactsContainer) contactsContainer.classList.remove("has-menu-btn");
      if (topBar) topBar.classList.remove("has-menu-btn");
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  requestAnimationFrame(updateNavBarPosition);
  window.addEventListener("resize", function () {
    requestAnimationFrame(updateNavBarPosition);
  });
  window.addEventListener("load", function () {
    requestAnimationFrame(updateNavBarPosition);
  });
  window.addEventListener("scroll", updateNavBarVisibility, { passive: true });
  updateNavBarVisibility();
}

function initInternalAccordions() {
  var body = document.body;
  if (!body || !window.UnifiedAccordion) return;

  if (body.classList.contains("kindergarten-page") &&
    typeof window.UnifiedAccordion.initKindergartenLearningAccordion === "function") {
    window.UnifiedAccordion.initKindergartenLearningAccordion();
  }
}

function initYandexMaps() {
  var mapEl = document.getElementById("block20_local_yandex_map");
  if (!mapEl) return;
  var loaded = false;

  function loadYandexMaps() {
    if (loaded) return;
    loaded = true;
    var s = document.createElement("script");
    s.src = "https://api-maps.yandex.ru/2.1/?apikey=5f83ec22-85a8-4723-a3ac-503a77f91a74&lang=ru_RU";
    s.async = true;
    s.onload = function () {
      function runMap() {
        if (typeof ymaps === "undefined") return;
        var fn =
          typeof window.initSecondaryContactsMap === "function"
            ? window.initSecondaryContactsMap
            : typeof window.initBlock20LocalMap === "function"
              ? window.initBlock20LocalMap
              : null;
        if (fn) {
          ymaps.ready(fn);
        } else {
          setTimeout(runMap, 50);
        }
      }
      runMap();
    };
    document.body.appendChild(s);
  }

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        io.disconnect();
        loadYandexMaps();
      }
    }, { rootMargin: "300px" });
    io.observe(mapEl);
  } else {
    loadYandexMaps();
  }
}

function initInternal2025() {
  syncSiteLanguage();
  initInternalHeaderScroll();
  initInternalAccordions();
  initYandexMaps();
  refreshPhoneMasks();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initInternal2025);
} else {
  initInternal2025();
}
